import React from "react";
import { PulseLoader } from "react-spinners";
import { theme } from "styles/mui-config";

const ChatLoadingCm = ({ size = 10, color = theme.palette.primary.dark }) => (
  <div
    style={{
      position: "absolute",
      borderRadius: "32px 32px 4px 4px",
      backgroundColor: "rgba(70, 70, 70, 0.4)",
      backdropFilter: "blur(5px)",
      fontWeight: "bold",
      width: "100%",
      height: "100%",
      zIndex: 1000000001,
      display: 'flex',
      alignItems: "center",
      justifyContent: "center"
    }}
  >
    <PulseLoader color={color} size={size} />
  </div>
);

export default ChatLoadingCm;
